import { render, staticRenderFns } from "./MoveReportingToDialog.vue?vue&type=template&id=03260b47&scoped=true"
import script from "./MoveReportingToDialog.vue?vue&type=script&lang=js"
export * from "./MoveReportingToDialog.vue?vue&type=script&lang=js"
import style0 from "./MoveReportingToDialog.vue?vue&type=style&index=0&id=03260b47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03260b47",
  null
  
)

export default component.exports